import { atom } from 'recoil';
import customStorage from './customStorage';

const key = 'jwt-token-configurator';

const atomToken = atom<string | null>({
  key,
  default: null,
  effects: customStorage(key),
});

export default atomToken;
